import React, { useState, useRef } from "react";
import axios from "axios";


const useCRUDController = ({
    onFinish = ({ axiosMode, status, values }) => { },
    onBefore = ({ axiosMode, status }) => { },
    apiRoute = "",
    propsCancel = true,
    includePatchErrorDetails = false
}) => {
    const [data, setData] = useState([])
    const [total, setTotal] = useState([])
    const [loading, setLoading] = useState(false)
    const [extendResponseData, setExtendResponseData] = useState([])
    const abortControllerRef = useRef(null); // 新增一個 ref 存 controller
    const cancelPending = () => {
        if (abortControllerRef.current) {
            abortControllerRef.current.abort();
            abortControllerRef.current = null;
        }
    }
    const getData = (params, options = { useCancelToken: true }) => {
        if (options.useCancelToken) {
            // 若已有先前的請求，則取消
            if (abortControllerRef.current) {
                if (propsCancel)
                    abortControllerRef.current.abort();
            }

            // 建立新的 Controller
            abortControllerRef.current = new AbortController();
        }
        onBefore({
            axiosMode: "get"
        })
        setLoading(true)
        return axios.get(apiRoute, {
            params: params,
            signal: options.useCancelToken ? abortControllerRef.current.signal : undefined
        })
            .then((response) => {
                let data = response.data
                setData(data?.data)
                setTotal(data?.total || 0)
                // setData()
                if (data) {
                    onFinish(
                        {
                            axiosMode: "get",
                            status: "success",
                            values: data?.data
                        }
                    )
                }
                else {
                    onFinish(
                        {
                            axiosMode: "get",
                            status: "error",
                            values: response.data
                        }
                    )
                }

                return {
                    ...data
                }
            })
            .catch((error) => {

                if (axios.isCancel?.(error) || error.name === 'CanceledError') {
                    // console.log("Request canceled", error.message);
                } else {
                    onFinish({
                        axiosMode: "get",
                        status: "error"
                    });
                }
                return Promise.reject(error); // 這樣呼叫方可以拿到錯誤


            })
            .finally(() => {
                setLoading(false)
            })
    }
    const postData = (data, mode = "default") => { // default mode  
        onBefore({
            axiosMode: "post"
        })
        setLoading(true)
        return axios.post(apiRoute,
            data
        )
            .then((response) => {
                let responseData = response.data
                let status = responseData?.status


                if (status === "success") {
                    onFinish(
                        {

                            values: { ...responseData },
                            axiosMode: "post",
                            status: "success"
                        }
                    )
                    return {
                        values: { ...responseData },
                        axiosMode: "post",
                        status: "success"
                    }
                }
                else {
                    onFinish(
                        {
                            values: { ...responseData },
                            axiosMode: "post",
                            status: "error"
                        }
                    )
                }
                if (mode === "default") {
                    return {
                        ...responseData?.values
                    }
                }
                else {
                    return responseData
                }


            })
            .catch((error) => {
                onFinish(
                    {
                        axiosMode: "post",
                        status: "error",
                        values: { ...error?.response?.data }
                    }
                )
                throw error // <--- 新增這行
            })
            .finally(() => {
                setLoading(false)
            })

    }
    const patchData = (data) => {
        onBefore({
            axiosMode: "patch"
        })
        setLoading(true)

        return axios.patch(apiRoute,
            data

        )
            .then((response) => {
                let responseData = response.data
                let status = responseData?.status
                if (status === "success") {
                    onFinish(
                        {
                            axiosMode: "patch",
                            status: "success"
                        }
                    )
                }
                else {
                    onFinish(
                        {
                            axiosMode: "patch",
                            status: "error",
                            ...(includePatchErrorDetails ? { values: responseData } : {})
                        }
                    )
                }
            })
            .catch((error) => {
                onFinish(
                    {
                        axiosMode: "patch",
                        status: "error",
                        ...(includePatchErrorDetails ? {
                            values: error?.response?.data ?? { message: error?.message }
                        } : {})
                    }
                )
            })
            .finally(() => {
                setLoading(false)
            })
    }
    const deleteData = (data) => {
        onBefore({
            axiosMode: "delete"
        })
        setLoading(true)
        return axios.delete(apiRoute,
            {
                data
            }
        )
            .then((response) => {
                let responseData = response.data
                let status = responseData?.status
                if (status === "success") {
                    onFinish(
                        {
                            axiosMode: "delete",
                            status: "success"
                        }
                    )
                }
                else {
                    onFinish(
                        {
                            axiosMode: "delete",
                            status: "error"
                        }
                    )
                }
            })
            .catch(() => {
                onFinish(
                    {
                        axiosMode: "delete",
                        status: "error"
                    }
                )
            })
            .finally(() => {
                setLoading(false)
            })
    }
    const exportData = (data) => {
        onBefore({
            axiosMode: "export"
        })
        return axios.get(`${apiRoute}_export/excel`,
            {
                responseType: 'blob',
                params: data,
            },
        )
            .then((response) => {
                let responseData = response.data
                const downloadUrl = window.URL.createObjectURL(new Blob([responseData]));
                const link = document.createElement('a');
                link.href = downloadUrl;
                link.setAttribute('download', '匯出清單.xlsx');
                document.body.appendChild(link);
                link.click();
                link.remove();
                setExtendResponseData(responseData)
                onFinish(
                    {
                        axiosMode: "export",
                        status: "success"
                    }
                )
            })
    }

    const scheduleExportData = (filters = {}) => {
        onBefore({ axiosMode: "export" })

        // ── Step 1：建立匯出排程 ──────────────────────────
        return axios.post(`${apiRoute}_export/batch`, { filters })
            .then((res) => {
                const file_schedule_id = res?.data?.file_schedule_id
                if (!file_schedule_id) {
                    throw new Error("未取得 file_schedule_id")
                }

                // ── Step 2：輪詢狀態，每 3 秒查一次 ──────────
                return new Promise((resolve, reject) => {
                    const poll = setInterval(async () => {
                        try {
                            const statusRes = await axios.get(`${apiRoute}_export/status`, {
                                params: { file_schedule_id }
                            })
                            const statusName = statusRes?.data?.status
                            const downloadUrl = statusRes?.data?.download_url
                            const statusId = statusRes?.data?.status_id
                            const dataCacheRes = statusRes?.data?.data_cache

                            console.log("[export] poll statusId:", statusId, "statusName:", statusName, "file_id:", dataCacheRes?.file_id)

                            console.log("[export] statusName:", statusName)
                            console.log("[export] downloadUrl:", downloadUrl)   // ← 加這行
                            console.log("[export] statusRes.data:", statusRes?.data)  // ← 加這行

                            // 用 status_id 判斷，不依賴 status 文字
                            if (statusId === 3 && dataCacheRes?.file_id) {
                                // 已完成，觸發下載
                                clearInterval(poll)

                                const file_id = dataCacheRes?.file_id
                                const file_name = dataCacheRes?.file_name ?? "匯出清單"
                                const file_name_extension = dataCacheRes?.file_name_extension ?? "xlsx"

                                axios.get(`/utility/file/blob`, {
                                    params: { file_id },
                                    responseType: 'blob',
                                })
                                    .then((blobRes) => {
                                        const downloadUrl = window.URL.createObjectURL(new Blob([blobRes.data]))
                                        const link = document.createElement('a')
                                        link.href = downloadUrl
                                        link.setAttribute('download', `${file_name}.${file_name_extension}`)
                                        document.body.appendChild(link)
                                        link.click()
                                        link.remove()
                                        window.URL.revokeObjectURL(downloadUrl)

                                        onFinish({ axiosMode: "export", status: "success" })
                                        resolve()
                                    })
                                    .catch((err) => {
                                        onFinish({ axiosMode: "export", status: "error" })
                                        reject(err)
                                    })

                            } else if (statusId !== 3 && statusId !== null && statusId !== undefined) {
                                // 非「已完成」也非「等待中/處理中」才算失敗
                                // 等待中和處理中繼續輪詢
                                const waitingOrProcessing = [/* 你系統的等待中、處理中 status_id */]
                                // 保守做法：只要不是 3 且 data_cache 有 error key 才停止
                                if (dataCacheRes?.error) {
                                    clearInterval(poll)
                                    onFinish({ axiosMode: "export", status: "error" })
                                    reject(new Error(dataCacheRes.error))
                                }
                                // 其他狀態繼續等待
                            }
                        } catch (err) {
                            clearInterval(poll)
                            onFinish({ axiosMode: "export", status: "error" })
                            reject(err)
                        }
                    }, 3000)
                })
            })
            .catch((err) => {
                onFinish({ axiosMode: "export", status: "error" })
                return Promise.reject(err)
            })
    }

    const importData = (data) => {
        onBefore({
            axiosMode: "import"
        })
        const files = data.target.files[0];
        let form_data = new FormData();
        form_data.append('inputFile', files);
        form_data.append('language', data?.choose_column);
        data?.guide && form_data.append('guide', data?.guide);
        form_data.append('default_column', JSON.stringify(data?.columns));
        data?.extra_data && form_data.append('extra_data', JSON.stringify(data?.extra_data));
        return axios
            .post(`${apiRoute}_import/read_sample`, form_data)
            .then((response) => {
                let responseData = response.data
                let status = responseData?.status
                setExtendResponseData(responseData.data)

                if (status !== "success") {
                    onFinish(
                        {
                            axiosMode: "import",
                            status: "error"
                        }
                    )
                    return {
                        values: { ...responseData },
                        axiosMode: "import",
                        status: "error"
                    }
                }
                else {
                    onFinish(
                        {
                            values: { ...responseData },
                            axiosMode: "import",
                            status: "success"
                        }
                    )
                    return {
                        values: { ...responseData },
                        axiosMode: "import",
                        status: "success"
                    }
                }
            })
            .catch(() => {
                onFinish(
                    {
                        axiosMode: "import",
                        status: "error"
                    }
                )
            })
    }
    const downloadData = ({ ...e } = {}) => {
        onBefore({
            axiosMode: "download_sample"
        })
        return axios
            .get(`${apiRoute}_import/manual`, {
                params: {
                    ...e
                },
                responseType: 'blob',
            })
            .then((response) => {
                let responseData = response.data
                const downloadUrl = window.URL.createObjectURL(new Blob([responseData]));
                const link = document.createElement('a');
                link.href = downloadUrl;
                link.setAttribute('download', '匯入範例.' + (e?.extension ?? 'xlsx'));
                document.body.appendChild(link);
                link.click();
                link.remove();
                setExtendResponseData(responseData)
                onFinish(
                    {
                        axiosMode: "download_sample",
                        status: "success"
                    }
                )
            })
    }
    const overData = (data) => {
        onBefore({
            axiosMode: "over"
        })
        return axios
            .post(`${apiRoute}_import/over_data`, data)
            .then((response) => {
                let responseData = response.data
                let status = responseData?.status

                if (status !== "success") {
                    onFinish(
                        {
                            axiosMode: "import",
                            status: "error"
                        }
                    )
                }
                else {
                    onFinish(
                        {
                            axiosMode: "import",
                            status: "success"
                        }
                    )
                }
            })
    }
    return {
        loading,
        ResponseDataTotal: total,
        ResponseData: data,
        ExtendResponseData: extendResponseData,
        getData,
        postData,
        patchData,
        deleteData,
        exportData,
        importData,
        downloadData,
        overData,
        cancelPending,
        scheduleExportData
    }
}
export { useCRUDController }

